module.exports = __webpack_public_path__ + "img/budget-plan.68e624fd.png";